import { ColumnConfig } from '../hooks/useTablePreferences';

export const promptColumns: ColumnConfig[] = [
  {
    key: 'name',
    label: 'Prompt Name',
    defaultWidth: 200,
    minWidth: 150,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'type',
    label: 'Type',
    defaultWidth: 120,
    minWidth: 100,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'sections',
    label: 'Sections',
    defaultWidth: 90,
    minWidth: 80,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'deployment',
    label: 'Deployment',
    defaultWidth: 110,
    minWidth: 90,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'priority',
    label: 'Priority',
    defaultWidth: 80,
    minWidth: 70,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'modelProvider',
    label: 'Provider',
    defaultWidth: 100,
    minWidth: 80,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'model',
    label: 'Model',
    defaultWidth: 120,
    minWidth: 80,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'thinkingLevel',
    label: 'Thinking',
    defaultWidth: 100,
    minWidth: 80,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'createdAt',
    label: 'Created',
    defaultWidth: 130,
    minWidth: 110,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
];
